<template>
  <div>
    <v-card v-if="PrenotazioneChiusa()">
      <v-card-title primary-title>
          <v-btn flat icon color="success">        
                <v-icon large >insert_emoticon</v-icon>                  
          </v-btn>
        <span class="headline">{{$store.state.labels.done}}</span >
        </v-card-title>
        <v-container>
          <div name ="istr_1" class="subheading">{{$store.state.labels.success_message}}</div>
          </v-container>
    </v-card>

    <v-card v-if="!PrenotazioneChiusa() && tutticompletati()">
      <v-card-title primary-title>
          <v-btn flat icon color="warning">        
                <v-icon large >mdi-help</v-icon>                  
          </v-btn>
        <span class="headline">{{$store.state.labels.instructions}}</span >
        </v-card-title>
        <v-container>
          <div name ="istr_1" class="subheading">{{$store.state.labels.all_data_inserted}}</div>
          </v-container>
    </v-card>

    <v-card v-if="!PrenotazioneChiusa() && !tutticompletati()">  
             <v-card-title primary-title>
          <v-btn flat icon color="warning">        
                <v-icon large >mdi-help</v-icon>                  
          </v-btn>
        <span class="headline">{{$store.state.labels.instructions}}</span >
        </v-card-title>
        <v-container>
          <div name ="istr_1" class="subheading">{{$store.state.labels.select_next_guest}}</div>
          </v-container>
        </v-card >

  </div>
</template>

<script>
/* eslint-disable no-prototype-builtins */
export default {
  data() {
    return {

    }
  },
  watch: {

    },
  methods: {
   tutticompletati : function () {
        var retval = true
        var indice =0
        console.log("TUTTI COMPILATI?");
        for (const key in this.$store.state.reservation.visitors) {
            
            indice++;
            if (this.$store.state.reservation.visitors.hasOwnProperty(key)) {
                const element = this.$store.state.reservation.visitors[key];
                console.log('visitor compiled->',indice,element.iscompiled);
                if(element.iscompiled)
                {
                    retval = true;
                }
                else
                {
                    retval = false;
                    break;
                }
            }
        }
        retval = retval && this.$store.state.reservation.mainguest.iscompiled
        console.log("capo completato:",this.$store.state.reservation.mainguest.iscompiled);
        console.log("tutti completati:",retval);


        return retval;
      },
      PrenotazioneChiusa : function () {
        console.log('stato prenotazione:',this.$store.state.reservation.status);
        return this.$store.state.reservation.status === 'CLOSED';
      },

      
  },
  created () {

    }
};
</script>